/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Icon,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import { namespaces, TRANSLATION_FILES } from '../../../constants/translation';

const CustomButtons = ({ onButtonAdd, onButtonCancel, onButtonUpdate, submitIsDisable, isEdit, t }) => {
  if (isEdit) {
    return (
      <div className="rdw-custom-buttons">
        <Button compact basic icon color="grey" size="small" className="rdw-cancel-button" onClick={onButtonCancel}><Icon name="x" /></Button>
        <Button compact basic color="blue" size="small" className="rdw-update-button" disabled={submitIsDisable} onClick={onButtonUpdate}><Icon name="checkmark" />{t('Update', { ns: TRANSLATION_FILES.translation })}</Button>
      </div>
    );
  }
  return (
    <div className="rdw-custom-buttons">
      <Button compact basic color="blue" size="small" className="rdw-add-button" disabled={submitIsDisable} onClick={onButtonAdd}><Icon name="send" />{t('Add Note')}</Button>
    </div>
  );
};

CustomButtons.propTypes = {
  isEdit: PropTypes.bool,
  onButtonAdd: PropTypes.func.isRequired,
  onButtonCancel: PropTypes.func.isRequired,
  onButtonUpdate: PropTypes.func.isRequired,
  submitIsDisable: PropTypes.bool,
  t: PropTypes.func,
};

export default withTranslation(namespaces)(CustomButtons);



// WEBPACK FOOTER //
// ./src/components/BookingNote/NoteEditor/CustomButtons.jsx